module.exports = __webpack_public_path__ + "img/dmytro-pryadko.747df4ff.jpeg";